module.exports = __webpack_public_path__ + "img/block_2.7cefdbb3.webp";